import { Phone, MessageCircle } from 'lucide-react';
import { Button } from '../ui/button';

export const HeroActions = ({ handleWhatsAppClick, handleCallClick }) => (
<div className="hero-actions">            <div className="flex flex-col sm:flex-row gap-4 justify-center px-4">
              <Button 
                data-testid="hero-whatsapp-button"
                onClick={handleWhatsAppClick}
                size="lg"
                className="bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white text-base md:text-xl px-6 md:px-12 py-5 md:py-8 transition-all duration-300 transform hover:scale-105 shadow-2xl shadow-green-500/40 font-bold w-full sm:w-auto flex items-center justify-center"
              >
                <MessageCircle className="w-5 h-5 md:w-6 md:h-6 mr-2 flex-shrink-0" />
                <span>WhatsApp Direct</span>
              </Button>
              <Button 
                data-testid="hero-call-button"
                onClick={handleCallClick}
                size="lg"
                variant="outline"
                className="border-2 md:border-3 border-white text-white hover:bg-white hover:text-black text-base md:text-xl px-6 md:px-12 py-5 md:py-8 transition-all duration-300 transform hover:scale-105 font-bold w-full sm:w-auto flex items-center justify-center"
              >
                <Phone className="w-5 h-5 md:w-6 md:h-6 mr-2 flex-shrink-0" />
                <span>Appeler</span>
              </Button>
            </div>

</div>
);
